
var isWeb;
var isTabl;
var isMobile;

function FixHeader() {
  if ( $( window ).scrollTop() > 0 ) {
    $("header").addClass('move');
    $(".m_icon").addClass('move');
    $(".mt").addClass('move');
  }
  else {
    $("header").addClass('move').removeClass('move');
    $(".m_icon").addClass('move').removeClass('move');
    $(".mt").addClass('move').removeClass('move');
  }

  setTimeout( FixHeader, 500 );
}

$( FixHeader );


$(document).ready(function(){

  $('[data-fancybox="images"]').fancybox({
    thumbs : {
      autoStart : false
    }
  });

  $('[data-fancybox="images02"]').fancybox({
    thumbs : {
      autoStart : false
    }
  });


	//自适应
	$(window).resize(function(){
		if( $(window).width() > 1180 ){ //桌面
			isWeb = true;
			isTabl = false;
			isMobile = false;
		}else if( 968 < $(window).width() && $(window).width() <= 1024 ){ //平板
			isWeb = false;
			isTabl = true;
			isMobile = false;
		}else if( 968 >= $(window).width() ){ //手机
			isWeb = false;
			isTabl = false;
			isMobile = true;
    }
    

    $windowW = $(window).width();
    $windowH = $(window).height();

    $('.winH').css('height', $windowH);
    $headerH = $('header').height();

    if(isTabl == true || isMobile == true){

    } else {

    };

  $('.index_empathy_business_school .list01').matchHeight({
      target: $('.index_empathy_business_school .list02')
  });


  });$(window).resize();
  



  $(".nav").slide({ type:"menu", titCell:".m", targetCell:".sub",effect:"slideDown",delayTime:300,triggerTime:0,returnDefault:true,defaultPlay:true});

  $(".head_link").slide({ type:"menu", titCell:".m", targetCell:".sub",effect:"slideDown",delayTime:300,triggerTime:0,returnDefault:true,defaultPlay:false});


  $(".index_empathy_business_school_list").slide({ titCell:".hd li", targetCell:".index_empathy_business_school_content",delayTime:0,triggerTime:0});



  var indexBannerPc = new Swiper ('.index_banner', {
    autoplay : 8000,
    autoplayDisableOnInteraction : false,
    loop: true,
    pagination : '.index_banner_page',
    paginationClickable :true,
    prevButton: '.index_banner_prev',
    nextButton: '.index_banner_next',
    onInit: function(swiper){ //Swiper2.x的初始化是onFirstInit
      swiperAnimateCache(swiper); //隐藏动画元素 
      swiperAnimate(swiper); //初始化完成开始动画
    }, 
    onSlideChangeEnd: function(swiper){ 
      swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
    } 
  });

  
  var EnterpriseCase = new Swiper ('.enterprise_case', {
    //autoplay : 8000,
    //autoplayDisableOnInteraction : false,
    //loop: true,
    //pagination : '.enterprise_case_page',
    //paginationClickable :true,
    slidesPerView: 2,
    slidesPerGroup: 2,
    slidesPerColumn: 2,
    spaceBetween: 50,
    prevButton: '.enterprise_case_prev',
    nextButton: '.enterprise_case_next',
    breakpoints: {
      668: {
      },
      968: {
      },
      1180: {
      },
      1681: {
        spaceBetween: 30,
      }
    }
  });

  
  var introHistory = new Swiper ('.intro_history_list', {
    //autoplay : 8000,
    //autoplayDisableOnInteraction : false,
    //loop: true,
    //pagination : '.intro_history_list_page',
    //paginationClickable :true,
    slidesPerView: 5,
    slidesPerGroup: 2,
    spaceBetween: 0,
    prevButton: '.intro_history_list_prev',
    nextButton: '.intro_history_list_next',
    breakpoints: {
      668: {
      },
      968: {
      },
      1180: {
      },
      1681: {
      }
    }
  });



});